import { Control } from '../../business-objects/control/control.model';
import { TextControlConfig } from './text-control-config.model';

export class TextControl extends Control {
    config: TextControlConfig;
}



// WEBPACK FOOTER //
// ./src/vas/controls/text/text-control.model.ts